module.exports = __webpack_public_path__ + "img/five.7a451b64.png";